module.exports = __webpack_public_path__ + "assets/9dc2d7d844cf801d31e89497027d7401.mp3";